import { render, staticRenderFns } from "./EleccertificateDrawer.vue?vue&type=template&id=cdbf5efe&scoped=true"
import script from "./EleccertificateDrawer.vue?vue&type=script&lang=ts"
export * from "./EleccertificateDrawer.vue?vue&type=script&lang=ts"
import style0 from "./EleccertificateDrawer.vue?vue&type=style&index=0&id=cdbf5efe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbf5efe",
  null
  
)

export default component.exports